function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.87385 6.66671C5.4284 6.66671 5.20532 6.12814 5.5203 5.81315L7.64653 3.68693C7.84179 3.49166 8.15837 3.49167 8.35363 3.68693L10.4799 5.81315C10.7948 6.12814 10.5718 6.66671 10.1263 6.66671H5.87385Z",
  fill: "#7A7A7A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.87385 9.33329C5.4284 9.33329 5.20532 9.87186 5.5203 10.1868L7.64653 12.3131C7.84179 12.5083 8.15837 12.5083 8.35363 12.3131L10.4799 10.1868C10.7948 9.87186 10.5718 9.33329 10.1263 9.33329H5.87385Z",
  fill: "#7A7A7A"
});

function SvgArrowDoubleFold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDoubleFold);
export default __webpack_public_path__ + "static/media/arrow_double_fold.3aa66b59.svg";
export { ForwardRef as ReactComponent };